import * as z from "zod";

export const updateGorgiasSmsNumber = {
  name: "updateGorgiasSmsNumber" as const,
  input: z.object({ smsPhoneNumber: z.nullable(z.string()) }),
  output: z.object({ success: z.boolean() }),
};
